export const ModalAddAvatarTranslationsCs = {
  'Add profile picture': 'Přidat profilový obrázek',
};
